import { BrowserRouter as Router } from 'react-router-dom'
import { useEffect } from 'react'
import { QueryClient, QueryClientProvider } from 'react-query'
import { ReactQueryDevtools } from 'react-query/devtools'
import { ThemeProvider } from '@mui/material/styles'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import theme from './theme/theme'
import MainRoutes from '_routes'
import CssBaseline from '@mui/material/CssBaseline'
import NetworkStatusNotifier from 'components/smart/NetworkStatusNotifier'
import {
  AUTH_END_REASON_KEY,
  clearAuthenticationCookies,
  subscribeToSessionLogout,
} from 'services/session/authSession'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: false,
      staleTime: 30000,
    },
  },
})

const App = () => {
  useEffect(() => {
    return subscribeToSessionLogout(({ reason }) => {
      clearAuthenticationCookies()
      sessionStorage.setItem(
        AUTH_END_REASON_KEY,
        reason || 'session-ended'
      )

      if (window.location.pathname !== '/login') {
        window.location.replace('/login')
      }
    })
  }, [])

  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <Router>
          <NetworkStatusNotifier />
          <MainRoutes />
          {/* <ReactQueryDevtools /> */}
        </Router>
        <ToastContainer hideProgressBar />
      </ThemeProvider>
    </QueryClientProvider>
  )
}

export default App
